import moment from "moment"
import { Log } from "../../types/logs"

export const formatLogs = (logs: Log[]) => {
  const formatted = logs.map((log) => ({
    order_id: log.order_id,
    creation_time: moment(log.creation_time).format("YYYY-MM-DD - HH:mm"),
    sync_time: moment(log.sync_time).format("YYYY-MM-DD - HH:mm"),
    status: log.status
      .split("_")
      .map((word: string) => word.substring(0, 1).toUpperCase() + word.substring(1).toLowerCase())
      .join(" ")
  }))

  return formatted
}
